module.exports = __webpack_public_path__ + "img/logo_xinyang.1d19ab65.jpg";